module.exports = __webpack_public_path__ + "media/images/application/icons/search-b1e157ea23070ce22ce7643f0acdddce.svg";